export const marathon = 42195; //distance in km
export const halfMarathon = 21098; //distance in km
export const other = 'other';
